let digitalScratcherService = require('./digital-scratcher-service');
let _scratcherService = new digitalScratcherService();
let _modal_scratcherService = new digitalScratcherService();

$(function () {
    let $pageScratcher = $('#interactive-scratcher-container');
    if (!$pageScratcher.length) return;

    _scratcherService.initializeScratcher($pageScratcher);

    let $modal = $('#interactive-scratcher-modal');
    if (!$modal.length) return;

    $modal.on('shown.bs.modal', function () {
        _modal_scratcherService.initializeScratcher($modal);
    });

});



// WEBPACK FOOTER //
// ./features/scratchers/digital-scratcher.js